export default {
	state: {
		versionNumber:	'1.3.40',
	},
}